// extracted by mini-css-extract-plugin
export default {"container":"Bio_container__ilZQ7","practitioner-profile-icon":"Bio_practitioner-profile-icon__bW9vd","description":"Bio_description__bMXp6"};